
  import { Vue, Component, Prop } from "vue-property-decorator";
  import ChipStatus from "@/entities/ChipStatus";

  @Component
  export default class StatusChip extends Vue {
    @Prop({ type: String, required: true }) readonly status!: ChipStatus;

    get styleClasses(): string {
      switch (this.status) {
        case ChipStatus.ATTENTION:
          return "bg-green-500";

        
        case ChipStatus.ALERT:
          return "bg-alert-red";

          case ChipStatus.INFO:
        default:
          return "bg-gray-400";
      }
    }
  }
